<div class="dig-dialog report-error-dialog">
  <div class="dialog-top-bar">
    <h3>{{ 'alert.report.title' | transloco }}</h3>
    <span
      (click)="close()"
      class="icon-close cta-btn"
      [class.disabled]="saving"
      inlineSVG="/icons/icon-close.svg"
    ></span>
  </div>

  <div class="dialog-content">
    <p class="dialog-description">{{ 'alert.report.intro' | transloco }}</p>

    <p class="reported-error">
      @if (data.errorMessage) {
        <span>{{ data.errorMessage }}</span>
      }
      <span class="request-id">Id: {{ data.requestId }}</span>
    </p>

    <form [formGroup]="form">
      <div class="form-field-container">
        <div class="form-field-label">
          <span class="required-label">{{ 'alert.report.description' | transloco }}</span>
          <span
            class="info-icon ml-2 dashboard-tooltip"
            matTooltipClass="dig-tooltip"
            #descriptionTooltip="matTooltip"
            (click)="descriptionTooltip.toggle()"
            [matTooltip]="'alert.report.description_info' | transloco"
          >
            <span inlineSVG="/icons/icon-info-circle-v2.svg"></span>
          </span>
        </div>
        <div class="textarea-container">
          <textarea
            formControlName="description"
            rows="6"
            [attr.maxlength]="DESCRIPTION_MAX_LENGTH"
            [placeholder]="'alert.report.description_placeholder' | transloco"
            [readonly]="saving"
            autocomplete="off"
          ></textarea>
          <p class="textarea-length">{{ description.value?.length || 0 }} / {{ DESCRIPTION_MAX_LENGTH }}</p>
        </div>
        @if (trimmedLength < DESCRIPTION_MIN_LENGTH) {
          <p class="field-hint">
            {{ 'alert.report.min_length' | transloco: { min: DESCRIPTION_MIN_LENGTH, count: trimmedLength } }}
          </p>
        }
        @if (description.hasError('api')) {
          <p class="field-error">
            {{ description.getError('api').message || ('alert.report.required' | transloco) }}
          </p>
        }
      </div>
    </form>
  </div>

  <div class="dialog-footer">
    <button type="button" class="btn btn-dark-theme btn-grey cta-btn" (click)="close()" [disabled]="saving">
      {{ 'global.cancel' | transloco }}
    </button>
    <button
      type="button"
      class="btn btn-dark-theme btn-primary cta-btn submit-btn"
      (click)="submit()"
      [disabled]="!canSubmit"
    >
      @if (saving) {
        <mat-spinner class="btn-spinner" [diameter]="16"></mat-spinner>
      }
      {{ 'alert.report.submit' | transloco }}
    </button>
  </div>
</div>
